// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LKdL","left":"styles_left__2s40k"};